import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { makeStyles } from '@material-ui/core/styles';

import {
  Card,
  CardContent,
  Typography,
  CardActions,
  Button,
  CardMedia,
} from '@mui/material';

const PAGE_SIZE = 8;

export default function EventPage() {
  const [pastEvents, setPastEvents] = useState([]);
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [visiblePastEvents, setVisiblePastEvents] = useState(PAGE_SIZE);
  const [visibleUpcomingEvents, setVisibleUpcomingEvents] = useState(PAGE_SIZE);

  const classes = useStyles();

  useEffect(() => {
    const headers = {
      'X-API-Key': 'YtDqedfkCo', // Replace with your actual token
    };

    axios
      .get('https://gdscdbapi-1-i8682496.deta.app/v1/events/past', { headers })
      .then(response => {
        setPastEvents(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching past events:', error);
        setError(error);
        setLoading(false);
      });

    axios
      .get('https://gdscdbapi-1-i8682496.deta.app/v1/events/upcoming', { headers })
      .then(response => {
        setUpcomingEvents(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching upcoming events:', error);
        setError(error);
        setLoading(false);
      });
  }, []);

  const loadMorePastEvents = () => {
    setVisiblePastEvents(prevVisiblePastEvents => prevVisiblePastEvents + PAGE_SIZE);
  };

  const loadMoreUpcomingEvents = () => {
    setVisibleUpcomingEvents(prevVisibleUpcomingEvents => prevVisibleUpcomingEvents + PAGE_SIZE);
  };

  if (loading) {
    return <h1>	<br /><br /><br />Loading... Data Please wait for few seconds</h1>;
  }

  if (error) {
    return <p>Error: {error.message}</p>;
  }

  return (
    <div>
      <section id="upcoming-events" className={classes.eventsSection}>
	  <br /><br /><br /><br />
        <center><h2>Upcoming Events</h2></center>
        {upcomingEvents.length > 0 ? (
          <div className={classes.cardContainer}>
            {upcomingEvents.slice(0, visibleUpcomingEvents).map(event => (
              <Card key={event.event_url} className={classes.card}>
                <CardMedia
                  component="img"
                  height="200px"
                  width="100%"
                  image={event.image_url}
                  alt="Event"
                  className={classes.imgContent}
                />
                <CardContent>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    className={classes.eventHeader}
                  >
                    {event.title}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {event.date}
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button
                    size="large"
                    href={event.event_url}
                    style={{ borderRadius: 35 }}
                    variant="contained"
                  >
                    View {'>'}
                  </Button>
                </CardActions>
              </Card>
            ))}
          </div>
        ) : (
          <center>
            <p>No upcoming events</p>
          </center>
        )}
        {visibleUpcomingEvents < upcomingEvents.length && (
          <div className={classes.loadMoreContainer}>
            <Button
              variant="contained"
              className={classes.loadMoreButton}
              onClick={loadMoreUpcomingEvents}
            >
              Load More
            </Button>
          </div>
        )}
      </section>

      <section id="past-events" className={classes.eventsSection}>
        <center><h2>Past Events</h2></center>
        <div className={classes.cardContainer}>
          {pastEvents.slice(0, visiblePastEvents).map(event => (
            <Card key={event.event_url} className={classes.card}>
              <CardMedia
                component="img"
                height="200px"
                width="100%"
                image={event.image_url}
                alt="Event"
                className={classes.imgContent}
              />
              <CardContent>
                <Typography
                  gutterBottom
                  variant="h5"
                  component="div"
                  className={classes.eventHeader}
                >
                  {event.event_title}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {event.event_date}
                </Typography>
              </CardContent>
              <CardActions>
                <Button
                  size="large"
                  href={event.event_url}
                  style={{ borderRadius: 35 }}
                  variant="contained"
                >
                  View {'>'}
                </Button>
              </CardActions>
            </Card>
          ))}
        </div>
        {visiblePastEvents < pastEvents.length && (
          <div className={classes.loadMoreContainer}>
            <Button
              variant="contained"
              className={classes.loadMoreButton}
              onClick={loadMorePastEvents}
            >
              Load More
            </Button>
          </div>
        )}
      </section>
    </div>
  );
}

const useStyles = makeStyles({
  eventsSection: {
    marginTop: '64px',
    marginBottom: '64px',
  },
  cardContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  card: {
    margin: '15px',
    width: '300px',
    backgroundColor: '#ffffff',
    borderRadius: '35px',
    border: '1px solid #707070',
    boxShadow: '0px 0px 25px rgba(0, 0, 0, 0.16)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  imgContent: {
    position: 'relative',
    height: '200px',
    width: '100%',
    backgroundColor: '#dbdada',
    borderRadius: '25px',
    boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.6)',
  },
  eventHeader: {
    fontFamily: "'Open Sans', sans-serif",
    fontSize: '18px',
    fontWeight: 'bold',
  },
  loadMoreContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px',
  },
  loadMoreButton: {
    borderRadius: '35px',
    backgroundColor: '#4caf50',
    color: '#ffffff',
    '&:hover': {
      backgroundColor: '#45a049',
    },
  },
});